// extracted by mini-css-extract-plugin
module.exports = {"embed":"spotify-embed_embed__t78QZ","is-compact":"spotify-embed_is-compact__p_CqD"};